export const MAX_CONVERSIONS = {
  key: 'maximizeConversions',
  text: _TL_('Maximize conversions'),
  marketingMetric: 'cpa',
  checkboxLabel: _TL_('Set a target cost per acquisition (CPA) (Optional)'),
  inputLabel: _TL_('Target cost per acquisition'),
  inputUnit: 'USD', // should overwrite this property with users currency
  minValue: 0.01,
  maxValue: 4000,
  type: 'MaxConversions',
};

export const MAX_CONVERSIONS_SCHEMA = {
  name: 'Product Schema',
  type: 'object',
  properties: {
    [MAX_CONVERSIONS.marketingMetric]: {
      type: 'number',
      required: false,
      minimum: MAX_CONVERSIONS.minValue,
      maximum: MAX_CONVERSIONS.maxValue,
    },
  },
};
